import { render } from "./tests-img.vue?vue&type=template&id=5b0bd44a&scoped=true"
import script from "./tests-img.vue?vue&type=script&lang=js"
export * from "./tests-img.vue?vue&type=script&lang=js"

import "./tests-img.vue?vue&type=style&index=0&id=5b0bd44a&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0bd44a"]])

export default __exports__